import { useState } from 'react'

import SortButton from './sortButton'
import {
  sortAlphabetical, sortAlphabeticalReverse, sortWorstBest, sortBestWorst,
  selectedAlphabetical, selectedAlphabeticalReverse, selectedWorstBest, selectedBestWorst
} from '../lib/sorting.js'

import styles from '../styles/Sort.module.css'


export default function Sort(props) {
  const [expanded, setExpanded] = useState(false)
  const [options, setOptions] = useState(selectedAlphabetical)

  const handleClick = (option) => {
    switch(option) {
      case 'A-Z':
        props.listSetter(sortAlphabetical(props.list))
        setOptions(selectedAlphabetical)
        break;
      case 'Z-A':
        props.listSetter(sortAlphabeticalReverse(props.list))
        setOptions(selectedAlphabeticalReverse)
        break;
      case 'Worst-Best':
        props.listSetter(sortWorstBest(props.list))
        setOptions(selectedWorstBest)
        break;
      case 'Best-Worst':
        props.listSetter(sortBestWorst(props.list))
        setOptions(selectedBestWorst)
        break;
      default:
        break;
    }
  }

  return (
    <div className={styles.relative} onClick={()=>{setExpanded(!expanded)}}>
      <div className={expanded ? [styles.expanded, styles.sort_container].join(' ') : styles.sort_container}>
        {options.map(option => <SortButton key={option.text} active={option.active} clickHandler={() => handleClick(option.text)} text={option.text}/>)}
      </div>
    </div>
  )
}
